export enum UserType {
  ADMIN = 'admin',
  PROPERTY_MANAGER = 'property_manager',
  INVESTOR = 'investor',
  ANONYMOUS = 'anonymous',
}
